
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { FeatureName } from './feature';
import { DunningActionDetailReducer } from './reducer';
import { effects } from './effects';


@NgModule({
	imports: [
		CommonModule,
		StoreModule.forFeature(FeatureName, DunningActionDetailReducer),
		EffectsModule.forFeature(effects)
	]
})

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class DunningActionDetailStoreModule {
}
